import trainingPhasesReportsActionCreators from './training-phase-reports';
import trainingPhasesCommitTypes from '../commit-types';

const trainingPhasesActions = {
  closeViewTrainingPhase() {
    return (dispatch) => {
      dispatch(this.setSelectedTrainingPhaseModal(false));
      setTimeout(() => dispatch(this.setSelectedTrainingPhaseGuid(null)), 310);
    };
  },
  loadTrainingPhaseDetail(phaseGuid) {
    return (dispatch) => {
      dispatch(this.fetchReportsForTrainingPhase(phaseGuid));
    };
  },
  resetTrainingPhasesState() {
    return {
      type: trainingPhasesCommitTypes.RESET_TP_PHASES_STATE,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_LOADING,
    };
  },
  setSelectedTrainingPhaseGuid(selectedGuid) {
    return {
      selectedGuid,
      type: trainingPhasesCommitTypes.SET_SELECTED_TRAINING_PHASE,
    };
  },
  setSelectedTrainingPhaseModal(modalOpened) {
    return {
      modalOpened,
      type: trainingPhasesCommitTypes.SET_SELECTED_TRAINING_PHASE_MODAL,
    };
  },
  unmountTrainingPhases() {
    return (dispatch) => {
      dispatch(this.resetTrainingPhasesState());
    };
  },
  viewTrainingPhase(selectedGuid) {
    return (dispatch) => {
      dispatch(this.setSelectedTrainingPhaseModal(true));
      dispatch(this.setSelectedTrainingPhaseGuid(selectedGuid));
      return dispatch(trainingPhasesReportsActionCreators.fetchReportsForTrainingPhase(selectedGuid));
    };
  },
};

export default trainingPhasesActions;
